import S from 'common/service/sanctuary';
import { compose, without, prop } from 'ramda';
import React from 'react';
import { connect } from 'react-redux';
import { func } from 'prop-types';
import { defineMessages, injectIntl, intlShape, FormattedMessage } from 'react-intl';
import { CollectionWrapper } from 'common/mdc/wrappers';
import Button from 'common/mdc/button';
import { StepperContent } from 'common/mdc/stepper';
import { SwitchField } from 'common/mdc/form';
import { ToolbarSection } from 'common/mdc/toolbar';
import { Pagination } from 'common/mdc/table';
import withMultiSelection from 'common/mdc/table/multiSelection';
import TextField from "common/mdc/textfield/index";
import Form, { Error, DisplayField } from "common/mdc/form/index";
import RadioField from 'common/mdc/form/radio';
import Select, { SelectItem } from 'common/mdc/select';
import { JOB_CONFIGURATION_GET_COMMANDS as get_cmd_list } from '../../../../constants';
import { JOB_CONFIGURATION_SET_COMMANDS as set_cmd_list } from '../../../../constants';
import { actions as jobsActions } from "@sma/store/job/jobs";

export const STEP_ID = Symbol('refine-selection');

const messages = defineMessages({
  title: {
    id: 'jobCreate.title.step3',
    defaultMessage: 'Configuration',
  },
  continue: {
    id: 'jobCreate.actions.continue3',
    defaultMessage: 'Continue',
  },
});

export const title = <FormattedMessage {...messages.title} />;

class Step3 extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      selectedConfigAction: "get",
      selectedGetCmd: null,
      selectedSetCmd: null,
      isContinueDisabled: true,
    };

    this.handleConfigChange = this.handleConfigChange.bind(this);
    this.handleCommandTypeSelect = this.handleCommandTypeSelect.bind(this);
    this.proceed = this.proceed.bind(this);

  }

  componentDidMount() {
    const { configAction, cmdType } = this.props.newJobEntries || {};
    if(cmdType !== null && configAction === "get"){
      this.setState({
        selectedConfigAction: configAction,
        selectedGetCmd: cmdType,
        isContinueDisabled: false,
      });
    }
    if(cmdType !== null && configAction === "set"){
      this.setState({
        selectedConfigAction: configAction,
        selectedSetCmd: cmdType,
        isContinueDisabled: false,
      });
    }
  }

  handleConfigChange(selectedVal) {
    const { resetstep3Details } = this.props;
    this.setState({
      selectedConfigAction: selectedVal,
      selectedGetCmd: null,
      selectedSetCmd: null,
      isContinueDisabled: true,
    },()=>{
      resetstep3Details();
    });
  }

  handleCommandTypeSelect(id) {
    const { selectedConfigAction } = this.state;
    selectedConfigAction === "get" ?
    this.setState({ selectedGetCmd: id, isContinueDisabled: false }) : this.setState({ selectedSetCmd: id, isContinueDisabled: false, });
  }

  proceed() {
    const { stepper, newJobEntries, saveStep3Details } = this.props;

    const { cmdType } = this.props.newJobEntries || {};

    // if(cmdType !== null && cmdType === ){
    //   return stepper.resolve({});
    // }

    const { selectedConfigAction, selectedGetCmd, selectedSetCmd } = this.state;
    if(selectedConfigAction === "get"){
      saveStep3Details({configAction: "get", cmdType: selectedGetCmd});
    }
    else{
      saveStep3Details({configAction: "set", cmdType: selectedSetCmd});
    }

    return stepper.resolve({
    });
  }

  render() {
    const {

      stepper,
      cancelAction,

    } = this.props;

    const { isContinueDisabled, selectedConfigAction, selectedGetCmd, selectedSetCmd } = this.state;

    return (
      <StepperContent
        loading={false}
        onSubmit={this.proceed}
        title={title}
        actions={[
          cancelAction,
          <Button raised type="submit" disabled={ isContinueDisabled }>
            <FormattedMessage {...messages.continue} />
          </Button>,
        ]}
        className="job-config-form-container"
      >
        <Form className={"create-job-form"}>
          <div className={"config-action-select-container"}>
            <DisplayField label={"Configuration Action:"} isRequired>
              <RadioField
                id={"config-action-get"}
                checked={selectedConfigAction === "get"}
                onChange = {() => this.handleConfigChange("get")}
                label={"GET"}
              />
              <RadioField
                id={"config-action-set"}
                checked={selectedConfigAction === "set"}
                onChange = {(e) => {e.stopPropagation();this.handleConfigChange("set");}}
                label={"SET"}
                disabled
              />
            </DisplayField>
          </div>
          <div className="command-type-container">
            <DisplayField label={"Command Type:"} isRequired>
              {
                selectedConfigAction === "get"
                ?
                <Select
                  key={"get-cmd-select"}
                  onChange={this.handleCommandTypeSelect}
                  value={selectedGetCmd}
                  id="get-cmd-select"
                >
                  {get_cmd_list.map(({ id, name }) => (
                    <SelectItem value={id} key={id}>
                      {name}
                    </SelectItem>
                  ))}
                </Select>
                :
                <Select
                  key={"set-cmd-select"}
                  onChange={this.handleCommandTypeSelect}
                  value={selectedSetCmd}
                  id="set-cmd-select"
                >
                  {set_cmd_list.map(({ id, name }) => (
                    <SelectItem value={id} key={id}>
                      {name}
                    </SelectItem>
                  ))}
                </Select>
              }
            </DisplayField>
          </div>
        </Form>
      </StepperContent>
    );
  }
}

export default compose(
  connect(
    state => ({
      newJobEntries: state.job.jobs.createJob
    }),
    {
      saveStep3Details: jobsActions.saveStep3Details,
      resetstep3Details: jobsActions.resetstep3Details,
    },
  ),
  injectIntl,
)(Step3);
